<template>
    <div class="cp-home-case">
        <div :style="{
            'background-image': 'url(' + data.bg + ')',
            'width': '100%',
            'height': '100vh',
            'background-size': 'cover'
        }"></div>
        <div class="cp-home-case-content">
            <div
              :class="[
                'cp-home-case-content-left',
                'cp-home-case-ani-start',
                isRender ? 'cp-home-case-ani-1' : ''
                ]">
                <div>
                    <div class="cp-home-case-title">{{ data.title }}</div>
                    <div class="cp-home-case-text">{{ data.text }}</div>
                    <div class="cp-home-case-line"></div>
                </div>
                <div>
                  <div class="cp-home-case-text2">{{ data.text2 }}</div>
                  <div class="cp-home-case-tip">{{ data.tip }}</div>
                </div>
            </div>
            <div class="cp-home-case-demo">
                <!-- demo phone -->
                <div :class="[
                    'cp-home-case-demo-phone',
                    'cp-home-case-ani-start',
                    isRender ? 'cp-home-case-ani-2' : ''
                  ]">
                  <swiper
                    ref="swiper"
                    class="cp-home-case-swiper"
                    :options="swiperOption">
                    <swiper-slide
                      v-for="(item, i) in data.list"
                      :key="i">
                      <img
                        :src="item.img"
                        style="width: 4rem; height: 8.02rem"/>
                    </swiper-slide>
                  </swiper>
                  <!-- bg -->
                  <div
                    class="cp-home-case-demo-bg"
                    :style="{
                      'transform': 'translate(-50%, -50%) rotate('+ angle +'deg)'
                    }">
                    <div :class="[
                      'cp-home-case-demo-round cp-home-case-demo-left',
                      current % 2 === 0 ? 'small' : ''
                    ]"></div>
                    <div :class="[
                      'cp-home-case-demo-round cp-home-case-demo-right',
                      current % 2 !== 0 ? 'small' : ''
                    ]"></div>
                  </div>
                </div>
                <div
                  :class="[
                    'cp-home-case-process',
                    'cp-home-case-ani-start',
                    isRender ? 'cp-home-case-ani-3' : ''
                  ]">
                  <!-- process -->
                  <div>
                    <span class="cp-home-case-process-current">0{{ current + 1 }}</span>
                    <span class="cp-home-case-process-total">/0{{ data.list.length }}</span>
                  </div>
                  <div class="cp-home-case-process-item">
                    <div
                      class="cp-home-case-process-item-inner"
                      :style="{
                        width: (1 / data.list.length * 100) + '%',
                        left: (current / data.list.length * 100) + '%'
                      }"></div>
                  </div>
                  <!-- case text -->
                  <div
                    v-for="(item, i) in data.list"
                    class="cp-home-case-process-text"
                    v-if="current === i">
                    <div style="font-size: .28rem;">{{ item.title }}</div>
                    <div style="font-size: .16rem; margin-top: .12rem;">{{ item.text }}</div>
                  </div>
                  <!-- case btn -->
                  <div class="cp-home-case-process-btn">
                    <img
                      src="@/images/left.png"
                      style="cursor: pointer;"
                      @click="onTapBtn('prev')"/>
                    <img
                      src="@/images/right.png"
                      style="margin-left: .623rem; cursor: pointer;"
                      @click="onTapBtn('next')"/>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const {Swiper, SwiperSlide}  = require('vue-awesome-swiper');
import 'swiper/css/swiper.css';
export default {
    name: 'cp-case',
    components: {
      Swiper,
      SwiperSlide
    },
    computed: {
      swiper() {
        return this.$refs.swiper.$swiper;
      }
    },
    props: {
      isInView: {
          type: Boolean,
          default: false
      },
      data: {
          type: Object,
          default() {
              return {};
          }
      }
    },
    data() {
        return {
            swiperOption: {
              spaceBetween: 30,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            current: 0,
            angle: 0,
            isRender: false
        }
    },
    watch: {
        isInView(v) {
            if (v) {
                this.play();
            }
            else {
                this.isRender = false;
                this.current = 0;
                this.angle = 0;
                this.swiper.slideTo(this.current);
            }
        }
    },
    mounted() {
      this.play();
    },
    methods: {
      play() {
          if (this.isInView) {
              setTimeout(() => {
                  this.isRender = true;
              }, 200);
          }
      },
      onTapBtn(type) {
        if (type === 'prev' && this.current > 0) {
          this.current = this.current - 1;
          this.angle = this.angle + 180;
        }
        if (type === 'next' && this.current < this.data.list.length - 1) {
          this.current = this.current + 1;
          this.angle = this.angle - 180;
        }
        this.swiper.slideTo(this.current);
      }
    }
}
</script>

<style scoped>
.cp-home-case {
    position: relative;
}
.cp-home-case-content {
    position: absolute;
    top: 0;
    bottom: 0;
    padding: 0 1.2rem;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    margin-top: .08rem;
}
.cp-home-case-content-left {
    display: flex;
    flex-direction: column;
    position: absolute;
    height: 8.02rem;
    margin-top: 1.16rem;
}
.cp-home-case-title {
    font-size: .54rem;
    font-weight: bold;
}
.cp-home-case-text {
    font-size: .2rem;
    margin-top: .21rem;
}
.cp-home-case-text2 {
    font-size: .28rem;
    margin-top: 1.13rem;
}
.cp-home-case-tip {
    font-size: .16rem;
    margin-top: .13rem;
}
.cp-home-case-line {
    width: .57rem;
    height: .04rem;
    background-color: #333;
    margin-top: .54rem;
}
.cp-home-case-demo {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .24rem;
    padding-left: 6.48rem;
}
.cp-home-case-swiper {
  width: 4rem;
  height: 8.02rem;
}
.cp-home-case-process {
  color: #D8D8D8;
  padding-left: 1.56rem;
}
.cp-home-case-process-item {
  position: relative;
  width: 2.25rem;
  height: .04rem;
  background-color: #d8d8d8;
  margin-top: .16rem;
}
.cp-home-case-process-item-inner {
    position: absolute;
    left: 0;
    top: -.02rem;
    background-color: #00C8C8;
    height: .07rem;
    transition: all .3s ease;
}
.cp-home-case-process-current {
  font-size: 1.6rem;
  font-weight: bold;
}
.cp-home-case-process-total {
  font-size: .32rem;
}
.cp-home-case-process-text {
  margin-top: .98rem;
  color: #333;
}
.cp-home-case-process-btn {
  margin-top: .91rem;
}
.cp-home-case-ani-start {
    transform: translateX(2.8rem);
    opacity: 0;
}
.cp-home-case-ani-1 {
    transition: all .6s ease-out;
    transform: translateX(0);
    opacity: 1
}
.cp-home-case-ani-2 {
    transition: all .5s ease-out .3s;
    transform: translateX(0);
    opacity: 1
}
.cp-home-case-ani-3 {
    transition: all .5s ease-out .5s;
    transform: translateX(0);
    opacity: 1
}
.cp-home-case-demo-phone {
    position: relative;
}
.cp-home-case-demo-bg {
    position: absolute;
    width: 6.01rem;
    height: 6.01rem;
    border: .02rem solid rgba(0, 200, 200, .2);
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 1s ease-out;
}
.cp-home-case-demo-round {
    position: absolute;
    background-color: rgba(0, 200, 200, .2);
    width: .32rem;
    height: .32rem;
    border-radius: 50%;
    border: .02rem solid #00C8C8;
    transition: all 1s ease-out;
}
.cp-home-case-demo-left {
    left: 0;
    top: 2.23rem;
    margin-left: -.13rem;
}
.cp-home-case-demo-right {
    right: 0;
    top: 3.34rem;
    margin-right: -.16rem;
}
.cp-home-case-demo-round::after {
    content: '';
    position: absolute;
    width: .13rem;
    height: .13rem;
    background-color: #00C8C8;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 1s ease-out;
}
.cp-home-case-demo-round.small {
    width: .3rem;
    height: .3rem;
    border: .01rem solid rgba(0, 200, 200, .2);
}
.cp-home-case-demo-round.small::after {
    width: .08rem;
    height: .08rem;
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Case.vue